import PostCardRow from './post-card-row'

export default PostCardRow
